export default __webpack_public_path__ + "static/media/LaserSinteringImg.fc20ef44.jpg";